<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      ref="forms"
      label-width="100px"
    >
      <el-form-item
        prop="orgName"
        label="机构名称"
      >
        <el-input type="text" v-model="form.orgName" placeholder="请填写机构名称"></el-input>
      </el-form-item>
      <el-upload
        class="avatar-uploader"
        :action="appApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <span v-if="!imageUrl" class="avatar-uploader-icon">点击上传logo</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="name"
        label="负责人"
      >
        <el-input type="text" v-model="form.name" placeholder="请填写负责人"></el-input>
      </el-form-item>
      <el-form-item
        prop="phone"
        label="电话"
      >
        <el-input type="text" v-model="form.phone" placeholder="请填写负责人电话"></el-input>
      </el-form-item>
      <el-form-item
        prop="fixPhone"
        label="机构固话"
      >
        <el-input type="text" v-model="form.fixPhone" placeholder="请填写机构固话"></el-input>
      </el-form-item>
      <el-form-item
        prop="addr"
        class="ipt-textarea"
        label="详细地址"
      >
        <el-input type="textarea" v-model="form.addr" placeholder="请填写详细地址"></el-input>
      </el-form-item>

      <el-form-item
        prop="description"
        label="公司简介"
        class="ipt-textarea"
      >
        <el-input type="textarea" v-model="form.description" placeholder="请填写公司简介" resize="none"></el-input>
      </el-form-item>

      <div class="tc">
        <el-button
          style="width: 140px"
          type="primary"
          @click="onSubmit">保存
        </el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
import {org} from '../../api'
import {validImage} from '@/utils'
import {getSession} from '../../utils/session'
import {ORG_CODE} from '../../constants'
export default {
  name: 'OrgForm',
  mounted () {
    this.getOrgDetail()
  },
  data () {
    let checkPhone = (rule, value, callback) => {
      if (value) {
        const isPhone = /^1[3456789]\d{9}$/
        const isMob = /^([0-9]{3,4}-)?[0-9]{7,8}$/
        if (isMob.test(value) || isPhone.test(value)) {
          callback()
        } else {
          return callback(new Error('电话号码格式错误'))
        }
      } else {
        callback()
      }
    }
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      loading: false,
      submitting: false,
      dialogFormVisible: false,
      imageUrl: '',
      form: {
        orgId: '',
        orgName: '',
        logoImg: '',
        addr: '',
        name: '',
        phone: '',
        fixPhone: '',
        description: ''
      },
      rules: {
        orgName: [
          {required: true, message: '请填写机构名称', trigger: 'blur'},
          {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
        ],
        addr: [
          {required: true, message: '请填写详细地址', trigger: 'blur'},
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ],
        name: [
          {required: true, message: '请填写负责人名称', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur'}
        ],
        phone: [
          {validator: checkPhone, trigger: 'blur'}
        ],
        fixPhone: [
          {required: true, message: '请填写机构固话', trigger: 'blur'},
          {validator: checkPhone, trigger: 'blur'}
        ],
        description: [
          {min: 1, max: 255, message: '长度在 1 到 255 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    async getOrgDetail () {
      this.loading = true
      let {data} = await org.getDetail(getSession(ORG_CODE))
      this.loading = false
      if (data.logoImg) {
        this.imageUrl = process.env.VUE_APP_IMG + data.logoImg
      }
      delete data.createTime
      this.form = data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    },
    async onSubmit () {
      this.$refs['forms'].validate((valid) => {
        if (valid) {
          this.updateOrg()
        } else {
          return false
        }
      })
    },
    async updateOrg () {
      this.submitting = true
      let {code, data} = await org.updateOrg({
        ...this.form
      })
      this.submitting = false
      if (code === 0) {
        this.$message({
          type: 'success',
          message: '机构信息修改成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '机构信息修改失败'
        })
      }
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.logoImg = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let validImage1 = validImage(file, 500)
      this.loading = validImage1
      return validImage1
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 232px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 575px;
          }
        }
      }
      .el-upload,
      .el-upload--text {
        margin-left: 410px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
      .customizeCssArea {
        margin-left: 307px;
        margin-top: -58px;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }

</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
